var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.085,
    height: 24.086,
    viewBox: "0 0 24.085 24.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    d: "M25.688,5.305l-11.5-3.284a.547.547,0,0,0-.3,0L2.4,5.305a.547.547,0,0,0-.4.527A22.492,22.492,0,0,0,7.895,21.6a19.525,19.525,0,0,0,5.932,4.44.547.547,0,0,0,.431,0,19.525,19.525,0,0,0,5.932-4.44A22.492,22.492,0,0,0,26.085,5.832.547.547,0,0,0,25.688,5.305Z",
    fill: "#0dbc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    d: "M14.951,4.04,4.006,7.167a21.337,21.337,0,0,0,5.6,14.61,19.255,19.255,0,0,0,5.348,4.082,19.248,19.248,0,0,0,5.348-4.08A21.344,21.344,0,0,0,25.9,7.169ZM19.5,21.031a18.8,18.8,0,0,1-4.548,3.592A18.839,18.839,0,0,1,10.4,21.03,20.111,20.111,0,0,1,5.127,7.985l9.824-2.807,9.824,2.807A20.115,20.115,0,0,1,19.5,21.031Z",
    transform: "translate(-0.908 -0.923)",
    fill: "#11977e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d-check",
    transform: "translate(-2.593 -6.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    d: "M12,19.09l3.09,3.09L21.271,16",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.8e4641ba6130144e758752814c71f451.svg";
export { ForwardRef as ReactComponent };